// extracted by mini-css-extract-plugin
module.exports = {"loading-dots":"LoadingSpinner_loading-dots__2H7IC","loading-dots--dot":"LoadingSpinner_loading-dots--dot__1TQOS","dot-keyframes":"LoadingSpinner_dot-keyframes__1cH4G"};